import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: 'animal-profile/:id',
    name: 'animal-profile',
    component: () => import('./views/AnimalProfile.view.vue'),
    children: [
      {
        path: 'medical',
        name: 'animal-profile-medical',
        component: () => import('./views/ProfileMedical.view.vue'),
      },
      {
        path: 'behavior',
        name: 'animal-profile-behavior',
        component: () => import('./views/ProfileBehavior.view.vue'),
      },
      {
        path: 'files',
        name: 'animal-profile-files',
        component: () => import('./views/ProfileFiles.view.vue'),
      },
      {
        path: 'groups',
        name: 'animal-profile-groups',
        component: () => import('./views/ProfileGroups.view.vue'),
      },
      {
        path: 'history',
        name: 'animal-profile-history',
        component: () => import('./views/ProfileHistory.view.vue'),
      },
      {
        path: 'change-log',
        name: 'animal-profile-change-log',
        component: () => import('./views/ProfileChangeLog.view.vue'),
      },
    ],
  },
  {
    path: '/shelter/animal/reintake/:id',
    name: 'reintake-form',
    component: () => import('./views/AnimalReintake.view.vue'),
  },
  {
    path: '/shelter/animal/lost-and-found/:id',
    name: 'lost-and-found-form',
    component: () => import('./views/AnimalLostAndFound.view.vue'),
  },
  {
    path: '/shelter/animal/rehome/:id',
    name: 'rehome-form',
    component: () => import('./views/AnimalRehome.view.vue'),
  },
];
